import regular_order from "./assets/regular_order.png";
import subscription_order from "./assets/subscription_order.png";

export const orderTypes = [{
    name: 'Regular Order',
    value: '0',
    img: regular_order
},
    {
        name: 'Subscription Order',
        value: '1',
        img: subscription_order
    }]

export const type = [
    {
        label: 'Daily',
        value: 'daily',
    },
    {
        label: 'Weekly',
        value: 'weekly',
    },
    {
        label: 'Monthly',
        value: 'monthly',
    },
]

export const weekDays = [{
    name: 'Monday', value: 1, time: ''
}, {
    name: 'Tuesday', value: 2, time: ''
}, {
    name: 'Wednesday', value: 3, time: ''
}, {
    name: 'Thursday', value: 4, time: ''
}, {
    name: 'Friday', value: 5, time: ''
}, {
    name: 'Saturday', value: 6, time: ''
}, {
    name: 'Sunday', value: 0, time: ''
},]
export const monthlyDays = [

    {
        name: 'Day 1', value: 1, time: ''
    }, {
        name: 'Day 2', value: 2, time: ''
    }, {
        name: 'Day 3', value: 3, time: ''
    }, {
        name: 'Day 4', value: 4, time: ''
    }, {
        name: 'Day 5', value: 5, time: ''
    }, {
        name: 'Day 6', value: 6, time: ''
    }, {
        name: 'Day 7', value: 7, time: ''
    },
    {
        name: 'Day 8', value: 8, time: ''
    }, {
        name: 'Day 9', value: 9, time: ''
    }, {
        name: 'Day 10', value: 10, time: ''
    }, {
        name: 'Day 11', value: 11, time: ''
    }, {
        name: 'Day 12', value: 12, time: ''
    }, {
        name: 'Day 13', value: 13, time: ''
    }, {
        name: 'Day 14', value: 14, time: ''
    },
    {
        name: 'Day 15', value: 15, time: ''
    }, {
        name: 'Day 16', value: 16, time: ''
    }, {
        name: 'Day 17', value: 17, time: ''
    }, {
        name: 'Day 18', value: 18, time: ''
    }, {
        name: 'Day 19', value: 19, time: ''
    }, {
        name: 'Day 20', value: 20, time: ''
    }, {
        name: 'Day 21', value: 21, time: ''
    },
    {
        name: 'Day 22', value: 22, time: ''
    }, {
        name: 'Day 23', value: 23, time: ''
    }, {
        name: 'Day 24', value: 24, time: ''
    }, {
        name: 'Day 25', value: 25, time: ''
    }, {
        name: 'Day 26', value: 26, time: ''
    }, {
        name: 'Day 27', value: 27, time: ''
    }, {
        name: 'Day 28', value: 28, time: ''
    },
    {
        name: 'Day 29', value: 29, time: ''
    },
    {
        name: 'Day 30', value: 30, time: ''
    },
    {
        name: 'Day 31', value: 31, time: ''
    },
]